import { useState, useEffect } from 'react';
import { loadTossPayments } from '@tosspayments/payment-sdk';
import constraints from '../constraints';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

export default function Subscribe() {
  const { currentUser, getSubscriptionStatus, getToken } = useAuth();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);

  useEffect(() => {
    async function init() { 

      try {
        const token = await getToken();
        axios.post(constraints.config.API_URL + '/analytics/event', {
          actionName: 'SUBSCRIBE_PAGE',
        },{
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      } catch (error) {
        console.log(error);
      }

      const {
        isRegisteredCard,
        isSubscriptionActivated
      } = await getSubscriptionStatus();

      if (!isRegisteredCard) {
        setSubscriptionStatus("NOT_REGISTERED_CARD");
      }

      if (isRegisteredCard && !isSubscriptionActivated) {
        // setAutoRenewCheckbox(false);
        setSubscriptionStatus("NOT_SUBSCRIBED");
      }

      if (isRegisteredCard && isSubscriptionActivated) {
        // setAutoRenewCheckbox(true);
        setSubscriptionStatus("SUBSCRIBED");
      }
    }

    init();
  }, []);

  const onPressSubscribe = () => {
    loadTossPayments(constraints.config.TOSS_CLIENT_KEY).then(tossPayments => {
      tossPayments.requestBillingAuth('카드', { // 결제 수단 파라미터
        // 빌링키 발급 요청을 위한 파라미터
        // customerKey : '고객 식별 키',
        // customerEmail : '고객 이메일', ( OPTIONS )
        customerName: currentUser.uid,
        customerKey: currentUser.uid,
        successUrl: constraints.config.TOSS_PAYMENT_SUCCESS_CALLBACK_URL,
        failUrl: constraints.config.TOSS_PAYMENT_FAIL_CALLBACK_URL
      })
    });
  }

  const onPressUnsubscribe = () => {
    
  }

  if (currentUser == null) {
    window.location.href = "/signin/kakao?redirect=/subscribe";
  }

  if (subscriptionStatus != null && subscriptionStatus == "SUBSCRIBED") {
    return (
      <div className="h-screen w-full flex flex-col bg-background bg-cover leading-normal p-8">

        <div className="flex flex-1 flex-col">
          <h1 className="text-white text-xl mb-3 font-extrabold">현재 구독중인 회원님입니다.</h1>

          <p className="text-white text-base mb-3">구독을 비활성화 하시려면 아래 버튼을 눌러주세요.</p>
        </div>
       
        <button className="bg-white text-black text-base font-bold py-2 px-4 rounded" onClick={onPressUnsubscribe}>구독 비활성화</button>
        
      </div>
    )
  }

  return (
    <div className="h-screen w-full flex flex-col bg-background bg-cover leading-normal p-8">
      <div className="flex flex-1 flex-col">
        <h1 className="text-white text-xl mb-3 font-extrabold">무제한 그림 그리기 구독</h1>

        <p className="text-white mb-10">
          구독을 통해 무제한으로 그림을 그릴 수 있습니다.
        </p>

        <h1 className="text-white text-xl mb-3 font-extrabold">구독시 이용가능 혜택</h1>

        <p className="text-white mb-1">
          * 무제한으로 이용 가능한 그림생성
        </p>

        <p className="text-white mb-1">
          * 애니메이션 그림 모델 11월 27일부터 무료 이용 가능
        </p>

        {/* <p className="text-white mb-1">
          * Mid Journey 커스템 모델 이용가능
        </p>  */}

      </div>

      <div className="flex flex-col">
        <h2 className="text-white text-lg mb-2 font-extrabold">환불약관</h2>

        <p className="mb-1 text-gray-500 font-semibold" style={{ fontSize: 11 }}>
          1. 구독을 시작하고, 서비스를 이용하기 전에 언제든지 환불 신청을 할 수 있습니다.
        </p>

        <p className="text-gray-500 mb-1" style={{ fontSize: 11 }}>
          2. 구독을 취소하면, 즉시 구독이 종료되며, 이후에는 더 이상 서비스를 이용할 수 없습니다.
        </p>

        <p className="text-gray-500 mb-3" style={{ fontSize: 11 }}>
          3. 구독을 시작하고, 구독권의 혜택을 이용한 후 환불 신청을 한 경우, 구독 당월의 구독료는 환불되지 않습니다.
        </p>
      </div>

      <button
        onClick={onPressSubscribe}
        type="button"
        className="mt-5 inline-flex items-center rounded border border-transparent bg-indigo-800 px-2.5 py-2.5 text-xl font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 self-center w-full justify-center">
        <div className="flex flex-col">
          <p className="text-center mb-1">구독하기</p>
          <p className="text-center text-sm">₩ 12500 / 월</p>
        </div>
      </button>
      
    </div>
  )
}